import { startTransition, useCallback, useEffect, useState } from 'react';
import { RenderJobList } from '@/components/app/RenderJobList';
import { listOrganizationRenders } from '@/services/renders';
import type { RenderJobSummary } from '@/types/api';
import { Button } from '@/components/primitives/Button';

export default function RendersPage() {
  const [rows, setRows] = useState<RenderJobSummary[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  const load = useCallback(() => {
    startTransition(() => {
      setLoading(true);
      setError('');
    });
    listOrganizationRenders({ limit: 200 })
      .then(setRows)
      .catch((err) => setError(err instanceof Error ? err.message : 'Failed to load renders'))
      .finally(() => setLoading(false));
  }, []);

  useEffect(() => {
    load();
  }, [load]);

  return (
    <div className="p-4 md:p-8 lg:p-12 space-y-10">
      {/* Header */}
      <div className="flex items-end justify-between gap-6 flex-wrap">
        <div className="space-y-1">
          <h1 className="text-4xl font-black tracking-tight text-on-surface font-headline">
            Renders
          </h1>
          <p className="text-on-surface-variant font-medium">
            Video export jobs for your organization. Download MP4s when status is completed.
          </p>
        </div>
        <Button onClick={() => load()} variant="outline" className="bg-surface-container-lowest">
          <span className="material-symbols-outlined text-[18px]">refresh</span>
          Refresh
        </Button>
      </div>

      {error ? (
        <div className="mb-8 p-4 rounded-xl bg-error-container text-on-error-container text-sm font-medium">
          {error}
        </div>
      ) : null}

      {loading ? (
        <div className="flex items-center justify-center py-20">
          <span className="material-symbols-outlined animate-spin text-4xl text-primary">
            progress_activity
          </span>
        </div>
      ) : (
        <RenderJobList
          rows={rows}
          showCreativeColumn
          emptyMessage="No renders have been generated yet."
        />
      )}
    </div>
  );
}
